module.exports = __webpack_public_path__ + "static/img/nav2.bf0b5b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav2.jpg
// module id = IsaR
// module chunks = 31